import React, { memo } from 'react';
import { Input, StartAdornment, SearchIcon } from './styles';
export function FuzzySearchInputSkeleton(props) {
  var _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'Search...' : _props$placeholder,
      style = props.style,
      className = props.className;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    placeholder: placeholder,
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(StartAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(SearchIcon, {
        color: "disabled"
      }))
    },
    disabled: true
  }));
}
export default /*#__PURE__*/memo(FuzzySearchInputSkeleton);